import React from "react";
import moment from "moment-timezone/builds/moment-timezone-with-data";
import swal from "sweetalert";

export const BASE_URL = `${process.env.REACT_APP_API_ENDPOINT_URL}${process.env.REACT_APP_API_VERSION}`;


export const utils = {
    download: (service, aux_file_name, file_extension) => {
        service.then(response => {
            if (response) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                const filename = `${aux_file_name}.${file_extension}`;
                link.href = url;
                link.setAttribute("download", filename);
                document.body.appendChild(link);
                link.click();
            }
        });
    },

    renderDate: (date, format = "DD/MM/YYYY", zone = "Asia/Colombo") => {
        if (date) {
            try {
                return date && date !== "" ? moment.tz(`${date}`, zone).format(format) : "";
            } catch (e) {
                console.log("error", e);
            }
        }
        return null;
    },
    dateToStr: (date, format = "YYYY-MM-DD") => {
        if (date) {
            try {
                return moment(date).format(format);
            } catch (e) {
                console.log("error", e);
                return null;
            }
        }
    },
    logGreen: data => console.log(`%c ${data} `, "background: #008000; color: #fff; padding: 8px; border-radius: 4px;"),
    blockLettersInputNumber: evt => {
        if (evt.which !== 8 && evt.which !== 0 && (evt.which < 48 || evt.which > 57)) {
            evt.preventDefault();
        }
    },
    splitText: text => {
        if (!text) {
            return [];
        }
        const new_text = text
            .replace(/,/g, " ")
            .replace(/;/g, " ")
            .replace(/\n/g, " ");
        return new_text.split(" ").filter(val => val);
    },
    clearObjectNulls: obj => {
        return Object.keys(obj).reduce((newObj, key) => {
            let value = obj[key];
            if (value !== null && value !== undefined && value !== "") {
                if (typeof value === "object" && !(value.constructor && value.constructor.name !== "Object")) {
                    value = utils.clearObjectNulls(value);
                    if (Object.keys(value).length > 0) {
                        newObj[key] = value;
                    }
                } else {
                    newObj[key] = value;
                }
            }
            return newObj;
        }, {});
    },
    strToDate: (str, format = "YYYY-MM-DD") => {
        try {
            const m = moment(str, format, true);
            return m.isValid() ? m.toDate() : null;
        } catch (e) {
            return null;
        }
    },
    strToDateTime: (str, format = "YYYY-MM-DD") => {
        try {
            if (str) {
                const str_date = str.split('T')[0]
                let parts = str_date.split('-')
                const date = new Date(parts[0], parts[1] - 1, parts[2]);
                return date
            }
            return null
        } catch (e) {
            return null
        }
    },
    computeError: error => {
        /**
        * This method handles responses error
        */
        if (error) {
            if (error.response) {
                if (error.response.status === 500) {
                    return `Something went wrong with the servers. Please contact 
                    support. Status code: 500`
                }
                if (error.response.data) {
                    if (typeof error.response.data === "object") {
                        return Object.keys(error.response.data)
                            .map(key => {
                                let mg = error.response.data[key];
                                if (Array.isArray(mg)) {
                                    mg.join(" ");
                                }
                                return `${mg}`.split("_").join(" ");
                            })
                            .join("\n");
                    }
                }
            }
            return `${error.message}`;
        }
    },
    redirect_oidc: () => {
        console.log(`${BASE_URL}/oidc/authenticate/`)
        window.location = `${BASE_URL}/oidc/authenticate/`;
    },
    redirect_oidc_logout: () => {
        window.location = `${BASE_URL}/auth/logout/`;
    },
    dateValidation: (start_date, end_date) => {
        /**
        * This method calculates difference between 2
        * given dates
        */
        const diffInMs = Math.abs(start_date - end_date);
        let month_difference = diffInMs / (1000 * 60 * 60 * 24 * 30);
        return month_difference
    },
    validateGeneral: (value) => {
        /**
        * This method validates if form fields are being
        * submited empty. Returns error if so
        */
        let error;
        if (!value) {
            error = "This field is required";
        }
        return error;
    },
    set_footer_html: () => {
        /**
        * This function is to set the footer html in the application(Temporary)
        */
        const html = `Copyright <b>NOKIA</b> ${new Date().getFullYear()} | Powered by <b>ZINA</b>`
        document.getElementsByClassName('legend')[0].innerHTML = html;
    },
    show_result_swal: (msg, success = true, title = 'Success') => {
        /**
        * This method return and alert to the end user
        * informing about the result of an action
        */
        return (success ? swal({
            title: title,
            text: msg,
            icon: "success",
            button: true
        }) : swal({
            title: title,
            text: msg,
            icon: "error",
            button: true
        }));
    },
    user_has_perm(user, perm_code) {
        /**
        * This method checks if user has a permission
        * code in both user permission and group permission
        */
        if (!user) return false
        
        if (user.is_superuser) return true
        
        if (!user.user_permissions) return false
        
        // Check user permissions
        const user_permission = user.user_permissions.find(
            perm => perm.codename === perm_code
        )
        
        if (user_permission) {
            return true
        }
        
        // Check group permissions
        const group_permissions = [];
        if (user.groups && Array.isArray(user.groups)) {
            user.groups.forEach(group => {
                if (group.permissions && Array.isArray(group.permissions)) {
                    group_permissions.push(...group.permissions);
                }
            })
            
            const group_permission = group_permissions.find(
                perm => perm.codename === perm_code
            )
            
            if (group_permission) {
                return true
            }
        }
        
        return false
    },
    // renderError(formik, type){
    //     if (formik.errors.hasOwnProperty(type) && formik.errors[type]) {
    //         return formik.errors[type];
    //     }
    //     return null;
    // },
    show_warning_message(action_method, props){
        /**
        * This method is created to show warning message
        * and if confirmed, sends a request to backend
        */
        return new Promise(resolve =>{
            swal({
                title: "Warning",
                text: 'This operation is not reversible. Are you sure to continue?',
                icon: "warning",
                buttons: {
                    continue: "Continue",
                    close: "Close"
                }
                }).then(action => {
                    switch (action) {
                        case "continue":
                            action_method(...props)
                            break;
                        default:
                            resolve(false)
                            break;
                    }
                });
        })
    },
    renderError:(formik, type) => {
        /**
        * This method is created to show error messages. Should be used in forms
        * to validate fields
        */
        if (formik.errors.hasOwnProperty(type) && formik.errors[type]) {
            return <small className="text-danger form-text">{formik.errors[type]}</small>;
        }
        return null;
    },
    errorMessage: () => {
        swal({
            title: "Warning ...",
            text: "An error has occurred while trying to download the report",
            icon: "warning",
            button: true
        });
    },
    check_validation_type:(cpo_register)=>{
        /**
        * This method is created to validate if ct has no validation
        */
       const validation_type = cpo_register ? cpo_register.validation_type : ''
       return !['no_validation'].includes(validation_type)
    }
};
